import React, { FC } from 'react';
import Form from 'components/Form';

import { PowerofresolvePageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Powerofresolve: FC<PowerofresolvePageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Powerofresolve;
